import {
  persistBookingAttribution,
  attributionLink,
} from 'shared/hooks/booking-attribution';
import React from 'react';
import { useLocation } from 'react-router';
import { useAppSelector } from './store';
import { trackPage } from './tracking';

export default function Tracking() {
  const { pathname, search } = useLocation();
  const businessId = useAppSelector((state) => state.public.businessId);
  const business = useAppSelector((state) => state.businesses.data[businessId]);
  React.useEffect(() => {
    if (business) persistBookingAttribution(business.id, search);
    if (business) trackPage(business.id, business.settings, pathname, search);
  }, [business, pathname, search]);
  React.useEffect(() => {
    if (!business) return;
    const onClick = (event: MouseEvent) => {
      const anchor = (event.target as Element)?.closest?.('a');
      if (!anchor || new URLSearchParams(search).has('preview_token')) return;
      const origins =
        business.handle && business.root_domain
          ? [`https://${business.handle}.${business.root_domain}`]
          : [];
      anchor.href = attributionLink(anchor.href, business.id, origins);
    };
    document.addEventListener('click', onClick, true);
    return () => document.removeEventListener('click', onClick, true);
  }, [business, search]);
  return null;
}
